module.exports = __webpack_public_path__ + "img/1.9577566a.png";